import * as React from 'react'
import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import NotFound from 'modules/core/components/NotFound'
import users from 'modules/core/store/collections/users'

import CollectionsBootstrap from 'modules/documents/lib/My_documentsCollectionsBootstrap'
import { CommonRouteContext } from 'modules/employees/lib/types'

export interface Tab {
  href: string
  name: string
}

interface RouteContext extends CommonRouteContext {}

const isAuthorized = (): boolean => {
  const employee = users.current.employee

  if (!employee) return false

  // TODO: readDocuments is now seeDocuments
  return employee.policy.can('readDocuments')
}

const Container = () => {
  const employee = users.current.employee
  const cardEmployeeRight = React.useRef<HTMLElement | null>(null)
  const headerTitle = React.useRef<HTMLElement | null>(null)

  if (!employee) return <NotFound />

  const context: RouteContext = {
    employee,
    cardEmployeeRight,
    headerTitle,
    canSeePersonalInfo: false,
    canEditPersonalInfo: false,
  }

  return (
    <AuthorizeUser authorizeFn={isAuthorized}>
      <Outlet context={context} />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
